export enum NotificationType {
    Marketing = "marketing",
    NewPatientNight = "new-patient-night",
    NewPatientShared = "new-patient-shared",
    NewNightComment = "new-night-comment",
    NewNightSigned = "new-night-signed",
    NewNightVersion = "new-night-version",
}
